module.exports = __webpack_public_path__ + "static/img/krFlag.e4e07b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header/krFlag.svg
// module id = GsNg
// module chunks = 55